/* ═══════════════════════════════════════
   mrk-cart.js
   Bundle preview + cart helpers
   ═══════════════════════════════════════ */

$(document).ready(function () {
  initBundle();
});

/**
 * initBundle()
 * Parses bundle JSON from .mrk-bundleItem-products divs
 * (rendered by mrkbundleCartItemsNew.liquid) and builds
 * the product breakdown HTML.
 *
 * Bundle JSON structure (array):
 * [
 *   {
 *     "name": "Polo Shirts/T-Shirts",
 *     "products": { "Product_1": { name, color, size, quantity, sku } },
 *     "positions": [ { name, appMethod } ]  // or object with numeric keys
 *   }
 * ]
 */
function initBundle() {
  $('.mrk-bundleItem-products').each(function () {
    var jsonString = $(this).text().trim();
    if (jsonString === '') return;

    var bundles;
    try {
      bundles = JSON.parse(jsonString);
    } catch (e) {
      try {
        bundles = JSON.parse(decodeURIComponent(jsonString));
      } catch (e2) {
        console.error('Bundle JSON parse failed:', e2);
        return;
      }
    }

    var bundleHtml = '';

    $.each(bundles, function (index, bundle) {
      var productHtml = '';

      $.each(bundle.products, function (productId, product) {
        productHtml +=
          '<li class="ItemCustomisations-customisationsItem-1jn mrk-bundle-product">' +
            '<div class="ItemCustomisations-customisationsActionsLeftAndItemRowWrapper-2yo">' +
              '<div class="ItemCustomisations-itemRow-1zn">' +
                '<div class="ItemCustomisations-customisationsApplication-3qW">' +
                  '<div class="ItemCustomisations-customisationsInlineIconsAndMethodWrapper-1Rj">' +
                    '<div class="bundleProductTitle">' + product.name + '</div>' +
                  '</div>' +
                  '<div class="ItemCustomisations-customisationsLocation-1BV">' +
                    '<b>Color</b>:' + product.color + '<br>' +
                    '<b>Size</b>:' + product.size +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>' +
            '<div class="ItemCustomisations-customisationsActionsRightAndPriceWrapper-3fe">' +
              '<div class="ItemCustomisations-customisationsActionsRight-LBN">' +
                '<div class="mrk-single-logo-cost">' +
                  '<b>Qty</b>: <span class="bundleProductQuantity">' + product.quantity + '</span>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</li>';
      });

      // Handle positions - both array and object formats
      var positions = bundle.positions || [];
      var posNames = [];
      if (Array.isArray(positions)) {
        positions.forEach(function (p) { posNames.push(p.name); });
      } else {
        $.each(positions, function (k, p) { posNames.push(p.name); });
      }
      var allPositions = posNames.join(', ');

      bundleHtml +=
        '<ul class="ItemCustomisations-customisations-5bC">' +
          '<h4 class="ItemCustomisations-customisationsTitle-12b mrk-mb-1">' + bundle.name + '</h4>' +
          '<div class="mrk-positions-wrap" mrk-positions="' + allPositions + '">' +
            '<b>Position(s)</b>: ' + allPositions +
          '</div>' +
          productHtml +
        '</ul>';
    });

    $(this).html(bundleHtml).show();
  });
}